import React from 'react';
import Search from '../Search';
import TruncatedList from '../TruncatedList';
import {t} from '../../util/i18n';
import {noop} from '@ultradent/utilities/Functions';

const FilterList = ( {
                         filter,
                         alwaysShowResults,
                         minQueryLength,
                         itemProps,
                         queryProps= [],
                         list= [],
                         renderer= noop,
                         onResultSelect= noop,
                         searchPlaceholder= null,
                         maxLength= 5,
                         enableSearchAtCount= 11,
                         className=''
                     } ) => {

    if ( !list || list.length <= 0 ) {
        return <div>{t( 'lists.label.empty', 'No Items in this list' )}</div>
    }

    const queryGroup = {list, queryProps, renderer, filter};

    if ( list.length > enableSearchAtCount ) {
        return (
            <Search
                minQueryLength={minQueryLength}
                resultLimit={maxLength}
                alwaysShowResults={alwaysShowResults}
                onResultSelect={onResultSelect}
                itemProps={itemProps}
                queryGroup={[queryGroup]}>
                {searchProps =>
                    <div data-testid="filterlist-pane" className={className}>
                        <span className="text-xs text-grey-dark mb-1 block">
                            {t(
                                'filterList.label.filterFromWithCount',
                                'Filter from {{count}} items in this list',
                                {count: list.length}
                            )}
                        </span>
                        <div className="flex w-full lg:flex-1 mb-4">
                            <Search.Input placeholder={searchPlaceholder}/>
                        </div>
                        <Search.Results activeClass="text-brand" noResultsClass="font-semibold mb-8">
                            {results => <div className="my-2" data-testid="filterlist-results">{results}</div>}
                        </Search.Results>
                        {!searchProps.hasResults &&
                            <div className="my-2">
                            <TruncatedList list={list} renderer={renderer} itemProps={itemProps} maxLength={maxLength}/>
                        </div>
                        }
                    </div>
                }
            </Search>
        );
    }

    return (
        <div data-testid="filterlist-pane">
            <TruncatedList list={list} renderer={renderer} itemProps={itemProps} maxLength={maxLength}/>
        </div>
    );
}

export default FilterList;
